import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import ContentSection from "sections/landingPage/ContentSection";

import styles from "./styles";

const InfoServices = () => {
  return (
    <Box position="relative">
      <ContentSection
        imageWidth={540}
        imageHeight={603}
        imagePath={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/aboutPage/ecosystem.png`}
        gridContainerProps={{ spacing: 6 }}
        title={
          <Typography
            component="h1"
            variant="h1"
            sx={{ textAlign: { xs: "center", lg: "left" } }}
          >
            What is Uniqly?
          </Typography>
        }
        text={
          <>
            <Typography
              paragraph
              sx={{ textAlign: { xs: "center", lg: "left" } }}
            >
              Uniqly.io enables creators, artists and brands to bridge physical
              and digital experiences. We provide the platform to launch
              next-layer e-commerce stores, fully automated, no-code solution
              where each physical product is sold through NFT with the
              possibility of redeeming to different metaverses.
            </Typography>
          </>
        }
        imageBoxProps={{
          sx: styles.image,
        }}
        reverse
      />
    </Box>
  );
};

export default InfoServices;
